import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import {getOrderDetails, redirectToMobilPay} from '../../../SHARED/actions/payment.actions';
import qs from 'qs';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';

class ThankYou extends Component{

    componentWillMount(){
        const search = qs.parse(this.props.location.search);
        this.props.getOrderDetails(search.orderId);
    }

    componentDidMount() {
        pageViewEvent('Confirmare comanda', window.location.href);
     }

    redirect = () => {
        const payload = {
            orderId: this.props.orderDetails.order_id,
            firstName: this.props.orderDetails.order_additional_details.first_name,
            lastName: this.props.orderDetails.order_additional_details.last_name,
            address: this.props.orderDetails.order_additional_details.address,
            email: this.props.orderDetails.order_additional_details.email,
            mobilePhone: this.props.orderDetails.order_additional_details.phone
        }
        this.props.redirectToMobilPay(payload);
    }

    orderDetails = () => {
        if (this.props.orderDetails){
            switch(this.props.orderDetails.order_status){
                case 1:
                    return (
                       <p className="thankyou-text text-center">Tranzacția dumneavoastră este în curs de procesare, vă rugăm sa verificați statusul pe pagina de profil, secțiunea bilete.</p>
                    );

                case 2:
                    return (
                        <Fragment>
                            <p className="thankyou-text text-center">A apărut o eroare. Tranzacția dumneavoastră nu a putut fi procesată. Vă rugăm 
                            <span onClick={this.redirect} className="redirect"> reîncercați!</span></p>
                        </Fragment>
                    );

                case 3:
                    return (
                        <p className="thankyou-text text-center">Tranzacția a fost efectuată, vă mulțumim și vă dorim vizionarea plăcută!</p>
                    );

                case 6:
                    return (
                        <Fragment>
                        <p className="thankyou-text text-center">A apărut o eroare. Tranzacția dumneavoastră nu a putut fi procesată. Vă rugăm 
                        <span onClick={this.redirect} className="redirect"> reîncercați!</span></p>
                    </Fragment>
                    );
                default:
            }
        }
    }

    render()
    {
        return (
            <div className="thankyou-page">
                <Spinner />
                <Helmet>
                    <title>Confirmare comanda</title>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                {this.orderDetails()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    orderDetails: state.payment.orderDetails
});
export default connect(mapStateToProps, {getOrderDetails, redirectToMobilPay})(ThankYou);



// WEBPACK FOOTER //
// ./src/FO/components/thankyou/thankyou.component.js